var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgWorkflowClipboard = function SvgWorkflowClipboard(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    fill: "none",
    viewBox: "0 0 19 19",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10.759,
    height: 14.156,
    x: 2,
    y: 3.964,
    stroke: "#4D4D4D",
    strokeWidth: 0.849,
    rx: 0.566
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.132 1.699H6.77V.239l3.726.372L14.22.238v1.46h1.67v14.157H5.13V1.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D4D4D",
    d: "M16.008 1.338H14.67V.446c0-.246-.2-.446-.446-.446H6.792c-.246 0-.446.2-.446.446v.892H5.008c-.246 0-.446.2-.446.446v14.195c0 .246.2.446.446.446h11c.246 0 .446-.2.446-.446V1.784c0-.246-.2-.446-.446-.446zM7.238.892h6.54v1.635h-6.54V.892zm8.324 14.641H5.454V2.23h.892v.743c0 .246.2.446.446.446h7.432c.246 0 .446-.2.446-.446V2.23h.892v13.303z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D4D4D",
    d: "M13.49 5.202H7.528c-.246 0-.446.2-.446.446s.2.446.446.446h5.962c.247 0 .446-.2.446-.446s-.2-.446-.446-.446zM13.49 7.618H7.528c-.246 0-.446.2-.446.446s.2.446.446.446h5.962c.247 0 .446-.2.446-.446s-.2-.446-.446-.446zM13.49 10.033h-2.98c-.247 0-.447.2-.447.446s.2.446.446.446h2.982c.246 0 .446-.2.446-.446s-.2-.446-.446-.446z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWorkflowClipboard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/workflow-clipboard.659ff028474c517a730efd8937728151.svg";